import useApiQueryData from "../use_api_query_data";
import { API_CLIENTS_BACKEND } from "../../api";
import XNGApiQueryParamObject from "../../../types/xng_api_query_param_object";

type Data = Awaited<ReturnType<typeof API_CLIENTS_BACKEND.getClientDistricts>>;
type QueryParams = {
  /** Account ref id. Undefined until the user picks an account; the query stays disabled. */
  clientId: string | undefined;
};

/**
 * Districts in an account — step three of the registration cascade. Each district carries the calling
 * user's own standing (`None` / `Granted` / `Pending`) so the picker can disable the ones there is no
 * point asking for.
 *
 * Not cached for long: the statuses go stale the moment the user submits, and a stale list is what
 * produces a 404 from the access-request endpoint.
 */
const useApiQueryGetClientDistricts = (
  paramObject: XNGApiQueryParamObject<QueryParams, Data>,
) => {
  const { clientId } = paramObject.queryParams;

  return useApiQueryData({
    queryFn: async () => await API_CLIENTS_BACKEND.getClientDistricts({ clientId: clientId! }),
    queryKey: ["getClientDistricts", clientId],
    enabled: Boolean(clientId),
    staleTime: 0,
    ...(paramObject.options ?? {}),
  });
};

export default useApiQueryGetClientDistricts;
